// Owner: views-grid; split out by performance-closure (plan §10.2). The route's `d` search schema reads
// the limit from here, so it does not load the draft codec (lz-string, view schemas) on first paint.

/** Longest `d` value we write (browsers and proxies cut URLs somewhere above 8 KB). */
export const DRAFT_MAX_LENGTH = 6000;
